import styled, { css, keyframes } from 'styled-components';

export const fadeIn = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;

export const fadeOut = keyframes`
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
`;

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  position: fixed;
  padding: 24px;
  color: #fff;
  background-color: #262626;
  animation-duration: 500ms;
  z-index: 9000;

  ${(p) =>
    p.$isShow &&
    css`
      animation-name: ${fadeIn};
    `}

  ${(p) =>
    p.$isHide &&
    css`
      animation-name: ${fadeOut};
    `}

  @media (max-width: 507px) {
    right: 16px;
    bottom: 16px;
    left: 16px;
  }

  @media (min-width: 508px) {
    right: 16px;
    bottom: 16px;
    width: 508px;
  }
`;

export const Title = styled.div`
  font-family: 'bourbon';
  font-size: 26px;
  font-weight: 300;
  line-height: 24px;
  text-transform: uppercase;
`;

export const Desc = styled.div`
  font-size: 13px;
  max-width: 650px;
  margin-top: 24px;
  margin-bottom: 40px;

  a,
  button {
    color: #dc8d3c;
  }
`;

export const StyledLink = styled.button`
  text-decoration: underline;
`;

export const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  column-gap: 8px;
`;

export const Button = styled.button`
  display: flex;
  align-items: center;
  height: 32px;
  padding: 0 24px;
  font-family: 'Esteban';
  font-size: 12px;
  letter-spacing: 0.6px;
  text-transform: capitalize;
  border-radius: 16px;
  cursor: pointer;

  &.--solid {
    color: #fff;
    background-color: #e88b53;
    border: 0 none;
  }

  &.--outline {
    color: #fff;
    background-color: transparent;
    border: 1px solid #c4c4c4;
  }
`;
